'use client'

import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/Button'

interface PaginationProps {
  currentPage: number
  pageCount: number
  totalCount: number
  onPrev: () => void
  onNext: () => void
  className?: string
  ariaLabel?: string
}

export function Pagination({
  currentPage,
  pageCount,
  totalCount,
  onPrev,
  onNext,
  className,
  ariaLabel = 'Paginação'
}: PaginationProps) {
  const canPrev = currentPage > 1
  const canNext = currentPage < pageCount

  return (
    <nav
      className={cn(
        'flex flex-nowrap items-center justify-center gap-2 sm:gap-3 pt-3',
        className
      )}
      aria-label={ariaLabel}
    >
      <Button
        type="button"
        variant="primary"
        size="sm"
        onClick={onPrev}
        disabled={!canPrev}
        className="shrink-0"
      >
        Anterior
      </Button>
      <span
        className="text-xs sm:text-sm text-gray-700 whitespace-nowrap"
        aria-live="polite"
      >
        Página {currentPage} de {pageCount}
        <span className="hidden sm:inline">
          {' '}
          ({totalCount} {totalCount === 1 ? 'resultado' : 'resultados'})
        </span>
      </span>
      <Button
        type="button"
        variant="primary"
        size="sm"
        onClick={onNext}
        disabled={!canNext}
        className="shrink-0"
      >
        Próxima
      </Button>
    </nav>
  )
}
